import { ApiEndpointHandler } from '@sonar-software/sonar-http';

import { patchDataSecurityMonitorById, PatchDataSecurityMonitorByIdRequest } from './patchDataSecurityMonitorById';

export type MuteDataSecurityMonitorByIdRequest = Pick<PatchDataSecurityMonitorByIdRequest, 'id' | 'isMuted'>;

export const muteDataSecurityMonitorById: ApiEndpointHandler<MuteDataSecurityMonitorByIdRequest> =
	(request, options) => patchDataSecurityMonitorById(request, options);
